/* global gtag */
import debounce from 'lodash.debounce';

export default function googleAnalyticsMiddleware() {
    const sendEventDebounced = debounce(() => {
        if (typeof gtag === 'function') {
            gtag('event', 'page_view', {
                page_location: window.location.pathname + window.location.search,
            });
        }
    }, 3000);

    return {
        onStateChange() {
            sendEventDebounced();
        },
        subscribe() {},
        unsubscribe() {},
    };
}
